import Validate from '../plugins/Validate';
import Registry from "../plugins/Registry";

class Form {
    static get(selector) {

        let instance = Registry.get('Form', selector);
        if (instance)
            return instance;

        instance = new Form(selector);
        Registry.set('Form', selector, instance);

        return instance;

    }

    constructor(selector) {

        this.selector = selector;

        if (typeof selector === 'string')
            this.form = $(this.selector);
        else
            this.form = this.selector;

        return this;
    }

    getValues() {
        const self = this;
        this.values = {};

        this.form.find('[name]').each(function () {
            self.values[$(this).attr('name')] = $(this).val();
        });

        return this.values;
    }

    isValid() {
        let msg,
            i,
            value,
            element;

        this.errors = {};
        this.values = this.getValues();

        if (this.form.find('[name="phone"]').length) {
            value = this.values.phone;
            if (value.length && !Validate.phone(value)) {
                msg = 'Укажите корректный телефон';
                this.errors.phone = msg;
                this.showError('phone', msg);
            } else {
                this.hideError('phone');
            }
        }


        if (this.form.find('[name="email"]').length) {
            value = this.values.email;

            if (value.length && !Validate.email(value)) {
                msg = 'Укажите корректный Email';
                this.errors.email = msg;
                this.showError('email', msg);
            } else {
                this.hideError('email');
            }
        }

        if (this.form.find('[name="date"]').length) {
            value = this.values.date;

            const maxDate = this.form.find('[name="date"]').attr('max');
            if (value.length && !Validate.date(value)) {
                msg = 'Укажите корректную дату';
                this.errors.date = msg;
                this.showError('date', msg);
            } else if (maxDate && new Date(value) > new Date(maxDate)) {
                msg = `Дата не может быть позже ${maxDate}`;
                this.errors.date = msg;
                this.showError('date', msg);
            } else {
                this.hideError('date');
            }
        }

        if (this.form.find('[name="message"]').length) {
            value = this.values.message;

            const minLength = this.form.find('[name="message"]').attr('minlength');
            if (value.length && value.length < minLength) {
                msg = `Введите не менее ${minLength} символов`;
                this.errors.message = msg;
                this.showError('message', msg)
            } else {
                this.hideError('message');
            }
        }


        for (i = 0; i < this.form.find('[required]').length; i++) {
            element = this.form.find('[required]').eq(i);
            const dataInput = element.data('input');
            const agreeList = ['agree', 'agree_personal', 'agree_politics'];

            if (agreeList.includes(element.attr('name'))) {
                const msg = 'Поле обязательно для заполнения';
                if (element.prop('checked')) {
                    this.hideError(element.attr('name'));
                } else {
                    this.errors[element.attr('name')] = msg;
                    this.showError(element.attr('name'), msg);
                }
                continue;
            }

            if (element.val() === '') {
                msg = 'Поле обязательно для заполнения';
                if (typeof dataInput === 'undefined') {
                    element.addClass('error');
                    this.errors[element.attr('name')] = msg;
                    this.showError(element.attr('name'), msg);
                }
                else {
                    $(dataInput).addClass('error');
                    this.errors[element.attr('name')] = msg;
                    this.showError($(dataInput).attr('name'), msg);
                }
            } else {

                if (typeof dataInput === 'undefined') {
                    if (!this.errors[element.attr('name')])
                        this.hideError(element.attr('name'));
                }
                else {
                    if (!this.errors[$(dataInput).attr('name')])
                        this.hideError($(dataInput).attr('name'));
                }
            }
        }


        for (i = 0; i < this.form.find('select[required]').length; i++) {
            element = this.form.find('select[required]').eq(i);
            if (element.parent().css('display') !== 'none') {
                if ((!element.val()) && (element.val() !== [])) {
                    element.parent().find('.select-head').addClass('error');
                    msg = 'Выберите одно из полей';
                    this.showError(element.attr('name'), msg);
                    this.errors[element.attr('name')] = msg;
                } else {
                    this.hideError(element.attr('name'));
                }
            }
        }

        return Object.keys(this.errors).length === 0;
    }

    url(value) {
        if (!value)
            return this.uri;

        this.uri = value;

        return this;
    }

    clear() {
        this.form.find('input:not([type="hidden"]):not([type="submit"]), select, textarea').val('');
        this.form.find('input, select, textarea').each(function () {
            $(this).next().text('');
        });
    }

    hideErrors() {
        for (const name in this.values) {
            if (this.values.hasOwnProperty(name)) {
                this.hideError(name);
            }
        }
    }

    hideError(name) {
        this.form.find('[name="' + name + '"]').removeClass('error');
        this.form.find('label[for="' + name + '"].error').remove();
    }

    showError(name, msg) {
        this.form.find('[name="' + name + '"]').addClass('error');
        if (this.form.find('[name="' + name + '"]').next('label.error[for="' + name + '"]').length)
            this.form.find('[name="' + name + '"]').next().html(msg);
        else
            this.form.find('[name="' + name + '"]').after('<label for="' + name + '" generated="true" class="error">' + msg + '</label>');
    }
}

export default Form;